import React, { useState, useEffect, useContext } from 'react';
import { LoginContext } from '../Login/LoginContext';
import axios from 'axios';
import Url from '../Url';
import './Sharecreate.css';

export default function Sharecreate() {
    const { loginResult } = useContext(LoginContext);
    const user_id = loginResult?.user_id;

    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);
    const [errorTemplates, setErrorTemplates] = useState(null);

    const [newFormData, setNewFormData] = useState({ templtname: '', message: '' });
    const [editFormData, setEditFormData] = useState({
        selectedTemplateName: '',
        templtname: '',
        message: '',
        id: '',
    });

    const [showNewForm, setShowNewForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);

    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const showPopupMessage = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
    };

    const fetchTemplates = async () => {
        if (!user_id) return;
        setLoadingTemplates(true);
        try {
            const report_id = 14;
            const res = await axios.get(`${Url.Url}/get_report?data={"user_id":"${user_id}","report_id":"${report_id}"}`);
            if (Array.isArray(res.data) && res.data.length > 0 && Array.isArray(res.data)) {
                setTemplates(res.data);
            } else {
                setTemplates([]);
            }
        } catch (e) {
            setErrorTemplates('Failed to load templates. Please try again.');
            setTemplates([]);
        } finally {
            setLoadingTemplates(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [user_id]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                setShowNewForm(prev => !prev);
                setShowEditForm(false);
            }
            if (e.key === 'F3') {
                e.preventDefault();
                setShowEditForm(prev => !prev);
                setShowNewForm(false);
            }
            if (e.key === 'Escape') {
                setShowNewForm(false);
                setShowEditForm(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleNewChange = (e) => {
        const { name, value } = e.target;
        setNewFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditSelectChange = (e) => {
        const selectedName = e.target.value;
        const selectedTemplate = templates.find(t => t.templtname === selectedName);
        if (selectedTemplate) {
            setEditFormData({
                selectedTemplateName: selectedName,
                templtname: selectedTemplate.templtname,
                message: selectedTemplate.message,
                id: selectedTemplate.id || '',
            });
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleNewSubmit = async (e) => {
        e.preventDefault();
        if (!user_id) return;

        const payload = {
            data: {
                templtname: newFormData.templtname,
                message: newFormData.message,
                Under_id: user_id,
                postid: 6,
            }
        };

        try {
            const res = await axios.post(`${Url.Url}/post_data`, payload, {
                headers: { 'Content-Type': 'application/json' },
            });
            showPopupMessage(res.data?.message || 'Template created!');
            setNewFormData({ templtname: '', message: '' });
            setShowNewForm(false);
            fetchTemplates();
        } catch (err) {
            showPopupMessage('Error creating template');
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!user_id || !editFormData.id) return;

        const payload = {
            data: {
                templtname: editFormData.templtname,
                message: editFormData.message,
                Under_id: user_id,
                postid: 7,
                id: editFormData.id,
            }
        };

        try {
            const res = await axios.post(`${Url.Url}/post_data`, payload, {
                headers: { 'Content-Type': 'application/json' },
            });
            showPopupMessage(res.data?.message || 'Template updated!');
            setShowEditForm(false);
            // ✅ Clear edit form
            setEditFormData({
                selectedTemplateName: '',
                templtname: '',
                message: '',
                id: '',
            });
            fetchTemplates();
        } catch (err) {
            showPopupMessage('Error updating template');
        }
    };

    return (
        <div className="share-create-container">
            {loadingTemplates && <p className="message-info">Loading templates...</p>}
            {errorTemplates && <p className="error-message">{errorTemplates}</p>}
           

            <div className="template-grid">
                {templates.map((template, i) => (
                    <div key={i} className="template-item">
                        <h3>{template.templtname}</h3>
                        <p className="template-message">{template.message}</p>
                    </div>
                ))}
            </div>

            {/* New Template Panel */}
            <div className={`off-canvas-panel ${showNewForm ? 'open' : ''}`}>
                <div className="off-canvas-header">
                    <h2>New Template</h2>
                    <button className="close-panel-button" onClick={() => setShowNewForm(false)}>&times;</button>
                </div>
                <form onSubmit={handleNewSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            name="templtname"
                            placeholder="Template Name"
                            value={newFormData.templtname}
                            onChange={handleNewChange}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="message"
                            placeholder="Message"
                            value={newFormData.message}
                            onChange={handleNewChange}
                            rows={6}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <button type="submit" className="submit-button">Create Template</button>
                </form>
            </div>

            {/* Edit Template Panel */}
            <div className={`off-canvas-panel ${showEditForm ? 'open' : ''}`}>
                <div className="off-canvas-header">
                    <h2>Edit Template</h2>
                    <button className="close-panel-button" onClick={() => setShowEditForm(false)}>&times;</button>
                </div>
                <form onSubmit={handleEditSubmit}>
                    <div className="form-group">
                        <label htmlFor="selectTemplate">Select Template</label>
                        <select
                            id="selectTemplate"
                            value={editFormData.selectedTemplateName}
                            onChange={handleEditSelectChange}
                            required
                            className="form-control"
                        >
                            <option value="" disabled>Select a template</option>
                            {templates.map((template, i) => (
                                <option key={i} value={template.templtname}>{template.templtname}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="templtname"
                            placeholder="Edit Template Name"
                            value={editFormData.templtname}
                            onChange={handleEditInputChange}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="message"
                            placeholder="Edit Message"
                            value={editFormData.message}
                            onChange={handleEditInputChange}
                            rows={6}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <button type="submit" className="submit-button">Update Template</button>
                </form>
            </div>

            {(showNewForm || showEditForm) && (
                <div
                    className="off-canvas-overlay"
                    onClick={() => {
                        setShowNewForm(false);
                        setShowEditForm(false);
                    }}
                ></div>
            )}

            {showPopup && (
                <div className="popup-message">
                    {popupMessage}
                </div>
            )}
        </div>
    );
}
